<t4-header icon="glyphicon-stats" title="{{'Turbo.Bookings.Dashboard.Headline' |translate : 'Dashboard' }}">
</t4-header>
<t4-container title="{{ 'Turbo.CustomerService.Map.lblFilter' |translate : 'Search filter' }}">
  <div class="filterToolbar">
    <div class="filterToolbarHeader">
      <div class="filterToolbarTitleBlock">
        <div class="filterToolbarTitleRow">
          <mat-icon>filter_alt</mat-icon>
          <div>
            <h2 class="filterToolbarTitle">Search filter</h2>
            <div class="filterToolbarSubtitle">Filter the data shown on the map and in the list.</div>
          </div>
        </div>
        @if(activeFilterCount > 0){
        <div class="filterToolbarCount">{{ activeFilterCount }} active</div>
        }
      </div>

      <div class="filterToolbarHeaderActions">
        <mat-checkbox *ngIf="type == 0" [formControl]="onlyMissingTrailers" (change)="updateFilter()">{{ 'Turbo.CustomerService.Map.lblMissingTrailers' | translate : 'Show only missing trailers'}}</mat-checkbox>
        <button mat-button color="primary" class="filterToolbarRefresh" (click)="refreshData()">Refresh data <mat-icon>refresh</mat-icon></button>
        <button mat-icon-button type="button" (click)="toggleFilterSection()" [attr.aria-label]="filterSectionCollapsed ? 'Expand filter section' : 'Collapse filter section'">
          <mat-icon>{{ filterSectionCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
        </button>
      </div>
    </div>

    @if(!filterSectionCollapsed){
    <div class="filterToolbarBody">
      <div class="filterGrid">
        <div class="filterField">
          <label>From date</label>
          <mat-form-field appearance="outline">
            <input matInput [matDatepicker]="lowerPicker" [(ngModel)]="lowerLimit">
            @if(lowerLimit){
            <mat-icon class="filterClearIcon" (click)="clearLowerDate($event)">clear</mat-icon>
            }
            <mat-datepicker-toggle matIconSuffix [for]="lowerPicker"></mat-datepicker-toggle>
            <mat-datepicker #lowerPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="filterField">
          <label>To date</label>
          <mat-form-field appearance="outline">
            <input matInput [matDatepicker]="higherPicker" [(ngModel)]="higherLimit">
            @if(higherLimit){
            <mat-icon class="filterClearIcon" (click)="clearHigherDate($event)">clear</mat-icon>
            }
            <mat-datepicker-toggle matIconSuffix [for]="higherPicker"></mat-datepicker-toggle>
            <mat-datepicker #higherPicker></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="filterField">
          <label>Concept</label>
          <mat-form-field appearance="outline">
            <mat-select [(ngModel)]="conceptRentalLocationGroup" (ngModelChange)="onConceptChange($event)" panelClass="rental-group-panel" (openedChange)="resetSearch($event, 'concept')">
              <div class="search-container filterDropdownSearch">
                <mat-form-field appearance="outline">
                  <input matInput [(ngModel)]="searchText" (keyup)="filterConcept()" placeholder="{{ 'Turbo.CustomerService.Map.lblSearchConceptType' | translate:'Type to search...' }}"
                         (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" />
                </mat-form-field>
              </div>
              <mat-option [value]="0">{{ 'Turbo.CustomerService.Map.lblAllConcepts' | translate : 'All concepts' }}</mat-option>
              <mat-option *ngFor="let group of filteredConcepts" [value]="group.Id">{{ group.Name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="filterField">
          <label>Group</label>
          <mat-form-field appearance="outline">
            <mat-select [(ngModel)]="rentalLocationGroup" (ngModelChange)="onGroupChange($event)" panelClass="rental-group-panel" (openedChange)="resetSearch($event, 'group')" [disabled]="conceptRentalLocationGroup == 3" (keydown.space)="$event.stopPropagation()">
              <div class="search-container filterDropdownSearch">
                <mat-form-field appearance="outline">
                  <input matInput [(ngModel)]="searchTextGroup" (keyup)="filterGroups()" placeholder="{{ 'Turbo.CustomerService.Map.lblSearchGroupType' | translate:'Type to search...' }}"
                         (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" />
                </mat-form-field>
              </div>
              <mat-option [value]="0">{{ 'Turbo.CustomerService.Map.lblAllGroups' | translate : 'All groups' }}</mat-option>
              <mat-option *ngFor="let group of filteredGroups" [value]="group.Id">{{ group?.Name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="filterField">
          <label>Location</label>
          <mat-form-field appearance="outline">
            <mat-select [(ngModel)]="locationId" (ngModelChange)="onLocationChange($event)" panelClass="rental-group-panel" (openedChange)="resetSearch($event, 'location')">
              <div class="search-container filterDropdownSearch">
                <mat-form-field appearance="outline">
                  <input matInput [(ngModel)]="searchTextLocation" (keyup)="filterLocation()" placeholder="{{ 'Turbo.CustomerService.Map.lblSearchLocation' | translate:'Type to search...' }}"
                         (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()"/>
                </mat-form-field>
              </div>
              <mat-option [value]="0">{{ 'Turbo.CustomerService.Map.lblAllLocation' | translate : 'All locations' }}</mat-option>
              <mat-option *ngFor="let location of filteredLocations" [value]="location.Id">{{ location?.Name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="filterActions">
        <button mat-stroked-button type="button" (click)="clearFilters()">Clear</button>
      </div>
    </div>
    }
  </div>
</t4-container>

<t4-container title="{{ 'Turbo.CustomerService.Map.lblMapOwerview' | translate : 'Map overview'}}" [isLoading]="mapLoading">
  <div class="mapLayout">
    <div class="mapCanvas">
      <div #gmap class="mapViewport"></div>
    </div>

    <aside class="mapSidePanel">
      <section class="mapPanelCard">
        <div class="mapPanelCardHeader">
          <h3>{{ 'Turbo.CustomerService.Map.lblLocationSearch' | translate : 'Find location' }}</h3>
        </div>
        <mat-form-field appearance="outline" class="panelField">
          <input #txtMapSearch matInput placeholder="{{ 'Turbo.CustomerService.Map.lblLocationSearch' | translate : 'Find location'}}" type="text" (focus)="onSearchFocus()" />
        </mat-form-field>
      </section>

      @if(selectedLocation != null){
      <section class="mapPanelCard">
        @if(locationLoading){
        <div class="loading-overlay">
          <mat-progress-spinner diameter="50" mode="indeterminate" color="primary"></mat-progress-spinner>
        </div>
        }

        <div class="mapPanelCardHeader">
          <div>
            <h3>{{ selectedLocation?.Name || selectedLocation?.ToString }}</h3>
            <p class="panelSubTitle">Station ID: {{ selectedLocation?.Id }}</p>
          </div>
          <button mat-icon-button type="button" aria-label="Close station details" (click)="closeSelectedLocation()">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="stationInfoBlock">
          <p>
            <b>Address</b>: {{selectedLocation.Address}} <br />
            <b>ZipCode</b>: {{selectedLocation.ZipCode}} <br />
            <b>City</b>: {{selectedLocation.City}}
          </p>

          <p>
            <b>Current address</b>: <br />
            {{ selectedLocationCordAddress != '' ? selectedLocationCordAddress : 'Resolving...' }}
          </p>
        </div>

        <div class="stationSettings">
          <div class="stationRadiusRow">
            <span>Radius (meters)</span>
            <mat-slider discrete min="1" max="200" step="1">
              <input matSliderThumb [(ngModel)]="selectedLocation.TrailerPointRadius" (ngModelChange)="onRadiusChange($event, selectedLocation?.Id)">
              <span class="slider-center-value">{{selectedLocation.TrailerPointRadius}}</span>
            </mat-slider>
          </div>

          <mat-slide-toggle color="warn" [(ngModel)]="isChecked" (change)="onTogglePin($event.checked, selectedLocation?.Id)">Unlock pin</mat-slide-toggle>
        </div>

        <div class="stationActions">
          <button mat-raised-button type="button" (click)="saveLocationChanges(selectedLocation)">Save</button>
        </div>
      </section>
      }

      <section class="mapPanelCard mapMissingCard">
        <div class="mapPanelCardHeader">
          <h3>Missing trailers ({{ missingTrailers.length }})</h3>
        </div>

        @if(missingTrailers.length > 0){
        <div class="missingTrailerList">
          @for (trailer of missingTrailers; track trailer.Id) {
          <div class="missingTrailerItem" tabindex="0" (click)="locateTrailer(trailer)" (keydown.enter)="locateTrailer(trailer)" (keydown.space)="locateTrailer(trailer); $event.preventDefault()">
            <div class="missingTrailerItemTopRow">
              <div>
                <div class="missingTrailerTitle">{{ trailer.Name }}</div>
                <div class="missingTrailerMeta">Assigned station: {{ trailer.LocationName || 'Unknown' }}</div>
              </div>
              <button mat-stroked-button color="primary" type="button" (click)="locateTrailer(trailer); $event.stopPropagation()">Locate</button>
            </div>
            <div class="missingTrailerDetailGrid">
              <div><b>RegNo.</b> {{ trailer.Name }}</div>
              <div><b>Last update</b> {{ formatTrailerLastUpdate(trailer) }}</div>
              <!--<div><b>Missing for</b> {{ getMissingDurationText(trailer) }}</div>-->
            </div>
          </div>
          }
        </div>
        }
        @else {
        <div class="emptyState">
          No trailers are currently marked as missing.
        </div>
        }
      </section>
    </aside>
  </div>
</t4-container>
